import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as Classes from './styles.module.scss';

const AddButton = ({
  doAddToCart,
  adding,
  added,
  failed
}) => {
  const onAddToCart = () => {
    if (adding) { return; }
    doAddToCart();
  };

  let text = <span>add to cart</span>;

  if (failed && !adding && !added) {
    text = <span>not added, try again</span>;
  } else if (!added && adding) {
    text = (
      <div className={ Classes.bl }>
        <div className={ Classes.b1 } />
        <div className={ Classes.b2 } />
        <div className={ Classes.b3 } />
      </div>
    );
  } else if (added) {
    text = (
      <span>added</span>
    );
  }

  return (
    <button
      type="button"
      className={ classnames(Classes.button, { [Classes.adding]: adding || added }) }
      onClick={ onAddToCart }
    >
      { text }
    </button>
  );
};

AddButton.propTypes = {
  doAddToCart: PropTypes.func.isRequired,
  adding: PropTypes.bool.isRequired,
  added: PropTypes.bool.isRequired,
  failed: PropTypes.bool
};

AddButton.defaultProps = {
  failed: false
};

export default AddButton;
